export const RouteNames = {
  HOME: 'home',
  DETAIL: 'cert-detail',
  DETAIL_WITH_LEVEL: 'cert-detail-with-level',
  JOINT: 'joint',
  CERT_EVALUATE: 'cert-evaluate',
  CERT_LIST: 'cert-list',
};
